import type { Engagement, EngagementSummary } from "../../lib/api-client/contracts";
import type { ContractListRow } from "./ContractDesktopList";
import type { MobileContractRow } from "../../components/MobileContractsList";
import { monthlySalaryText } from "../../components/JobOffer";
import { statusChipClass, type ContractStatusFilter } from "./model";

export function engagementStatusKey(engagement: Engagement): Exclude<ContractStatusFilter, "all"> {
  if (!engagement.paymentRequired) return engagement.status;
  if (!engagement.paymentContractId) return "signature";
  if (engagement.paymentStatus === "pending_funding") return "funding";
  if (engagement.paymentStatus === "funded") return "active";
  if (engagement.paymentStatus === "disputed") return "disputed";
  return engagement.status;
}
export function engagementStatusLabel(engagement: Parameters<typeof engagementStatusKey>[0]) {
  if (!engagement.paymentRequired) return { active: "In progress", completed: "Completed", cancelled: "Cancelled" }[engagement.status];
  if (!engagement.paymentContractId) return "Agreement needed";
  if (engagement.paymentStatus === "pending_funding") return "Awaiting signatures or funding";
  if (engagement.paymentStatus === "funded") return "In progress";
  return engagement.paymentStatus ?? engagement.status;
}

/** List projections keep Job status/role and monthly salary separate from contract price and funded state. */
export function engagementListRows(engagements: readonly EngagementSummary[]): ContractListRow[] {
  return engagements.map(engagement => ({ id: `engagement:${engagement.id}`, title: engagement.jobTitle, amount: null,
    valueLabel: engagement.agreedSalary == null ? "Unknown salary" : monthlySalaryText(engagement.agreedSalary),
    createdAt: engagement.createdAt, role: engagement.role, counterparty: engagement.counterpartName, sourceLabel: "Job",
    statusKey: engagementStatusKey(engagement), statusLabel: engagementStatusLabel(engagement), statusClass: statusChipClass(engagementStatusKey(engagement)),
    href: `/contracts?engagement=${encodeURIComponent(engagement.id)}` }));
}
export function mobileEngagementRows(engagements: readonly EngagementSummary[]): MobileContractRow[] {
  return engagementListRows(engagements).map(row => ({ id: row.id, title: row.title, counterparty: row.counterparty || "",
    roleLabel: row.role === "employer" ? "Employer" : "Worker", stage: row.statusKey, statusLabel: row.statusLabel,
    statusClass: row.statusClass, amount: null, valueLabel: row.valueLabel, createdAt: row.createdAt, href: row.href }));
}
